





















import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "cwx-img",

  props: {
    //The image URL. This prop is mandatory.
    src: {
      type: String as PropType<string | null | undefined>,
      required: false,
      default: undefined
    },
    //Generating alternate text and a role for screen readers (example use: :alt="$t('Image')").
    alt: {
      type: String,
      required: false,
      default: undefined
    },
    //Calculated as width/height, so for a 334x200px image this will be 1.67. Will be calculated automatically if omitted.
    aspectRatio: {
      type: [String, Number],
      required: false,
      default: undefined
    },
    //Prevents the image from being cropped if it doesn't fit.
    contain: {
      type: Boolean,
      required: false,
      default: false
    },
    //Overrides the default to change which parts get cropped off. Uses the same syntax as background-position.
    position: {
      type: String,
      required: false,
      default: "center center"
    },
    //Sets the minimum height for the content.
    minHeight: {
      type: [String, Number],
      required: false,
      default: undefined
    },
    //Sets the height for the content.
    height: {
      type: [String, Number],
      required: false,
      default: undefined
    }
  },

  data() {
    return {
      paddingBottom: undefined as string | undefined
    };
  },

  mounted() {
    if (!!this.aspectRatio && this.aspectRatio != 0) {
      //If a non-zero value for aspect ratio of an image is given via the 'aspectRatio' prop
      this.paddingBottom = (1 / Number(this.aspectRatio)) * 100 + "%";
    } else {
      //Calculating the original aspect ratio of an image
      const img = new Image();
      img.src = this.src || "";
      img.onload = () => {
        const naturalWidth = img.naturalWidth;
        const naturalHeight = img.naturalHeight;
        const calculatedAspectRatio =
          !!naturalHeight && !!naturalWidth
            ? naturalWidth / naturalHeight
            : undefined;

        this.paddingBottom = !!calculatedAspectRatio
          ? (1 / Number(calculatedAspectRatio)) * 100 + "%"
          : undefined;
      };
    }
  }
});
